// extracted by mini-css-extract-plugin
export default {"main":"Content_main__R2E2v","content":"Content_content__1KRUE"};